import type { DirectiveBinding, ObjectDirective } from 'vue'

interface HTMLElementWithClickOutsideEvent extends HTMLElement {
	clickOutsideEventHandler?: (event: Event) => void
}

const clickOutsideDirective: ObjectDirective<HTMLElementWithClickOutsideEvent> = {
	mounted(el: HTMLElementWithClickOutsideEvent, binding: DirectiveBinding<unknown>) {
		el.clickOutsideEventHandler = (event: Event): void => {
			if (!(el === event.target || el.contains(event.target as Node))) {
				if (typeof binding.value === 'function') {
					binding.value(event)
				}
			}
		}
		document.body.addEventListener('click', el.clickOutsideEventHandler)
	},

	beforeMount(el: HTMLElementWithClickOutsideEvent) {
		if (el.clickOutsideEventHandler) {
			document.body.removeEventListener('click', el.clickOutsideEventHandler)
		}
	},
}

export default clickOutsideDirective
